import { render, staticRenderFns } from "./PieChartCard.vue?vue&type=template&id=0e53b5f8&"
import script from "./PieChartCard.vue?vue&type=script&lang=ts&"
export * from "./PieChartCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports